var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEllipseSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 155,
    viewBox: "0 0 70 155",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.0001 41.5061C64.373 52.236 61.1898 64.4489 61.1898 77.4052C61.1898 90.3615 64.373 102.574 70.0001 113.304C57.0605 137.978 31.1986 154.81 1.40518 154.81C-41.3445 154.81 -76 120.155 -76 77.4052C-76 34.6555 -41.3445 0 1.40518 0C31.1986 0 57.0605 16.8324 70.0001 41.5061ZM1.40518 118.581C-21.3358 118.581 -39.7711 100.146 -39.7711 77.4052C-39.7711 54.6642 -21.3358 36.2289 1.40518 36.2289C24.1462 36.2289 42.5814 54.6642 42.5814 77.4052C42.5814 100.146 24.1462 118.581 1.40518 118.581Z",
    fill: "#0C2C40"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEllipseSmall);
export default __webpack_public_path__ + "static/media/ellipse_small.31b32d3e24989cad9806550d1cce4ed9.svg";
export { ForwardRef as ReactComponent };